// extracted by mini-css-extract-plugin
export default {"turnsFooter":"_1Z3Q2XAs1cMjGklQ4-VTVK","logos":"_3NKiVpT8ecd8bbZL_L5p_0"};